import React, { useContext } from 'react';
import classnames from 'classnames';
import { ArrowRight, ArrowLeft, ChevronRight, ChevronLeft } from 'react-feather';

import { LinkComponentFragment } from '../../../graphql.schema';
import { PageContext } from '../PageContext';
import { v4tov3base } from '../../lib/mapV4toV3';

import * as linkStyles from '../StrapiLink/StrapiLink.module.scss';
import * as styles from '../ModalButton/ModalButton.module.scss';

type Props = LinkComponentFragment & {
  type?: 'primary' | 'secondary';
  modalButtonType: 'button' | 'link';
  icon?: 'Arrow' | 'Chevron';
  hideIcon?: boolean;
  className?: string;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const ModalContent: React.FC<Props> = (props) => {
  const { websiteLocale } = useContext(PageContext);
  const { hasRightToLeftLanguage } = v4tov3base({ ...websiteLocale.attributes });
  switch (props.modalButtonType) {
    case 'button':
      return (
        <button
          className={classnames(props.className, styles.root, 'button', {
            [styles.secondary]: props.type === 'secondary',
          })}
          onClick={() => props.setIsOpen(true)}
        >
          {props.children ?? (
            <>
              <span className={styles.content}>{props.title}</span>
              {hasRightToLeftLanguage ? (props.hideIcon ? null : props.icon === 'Chevron' ? <ChevronLeft data-testid="chevron-left-icon" size={24} /> : <ArrowLeft data-testid="arrow-left-icon" size={24} />) : (props.hideIcon ? null : props.icon === 'Chevron' ? <ChevronRight data-testid="chevron-right-icon" size={24} /> : <ArrowRight data-testid="arrow-right-icon" size={24} />)}
            </>
          )}
        </button>
      );
    case 'link':
      return (
        <a className={classnames(linkStyles.link)} onClick={() => props.setIsOpen(true)}>
          {props.title}
          {hasRightToLeftLanguage ? (props.hideIcon ? null : props.icon === 'Chevron' ? <ChevronLeft data-testid="chevron-left-icon" size={24} /> : <ArrowLeft data-testid="arrow-left-icon" size={24} />) : (props.hideIcon ? null : props.icon === 'Chevron' ? <ChevronRight data-testid="chevron-right-icon" size={24} /> : <ArrowRight data-testid="arrow-right-icon" size={24} />)}
        </a>
      );
    default:
      return <>{props.children}</>;
  }
};

export default ModalContent;
